import * as constants from './constants';
import { router } from './router';
import { menu } from './menu';
import { NdSkladPreceneni } from './ndSkladPreceneni';
import { NdSklad } from './ndSklad';
import { NdPohyb } from './ndPohyb';
import { NdObjednavka } from './ndObjednavka';
import { PROrders } from './PROrders';
import { NdCenik } from './ndCenik';
import { PRInvoice } from './PRInvoice';
import { PRReturn } from './PRReturn';
import { CustomerPendingEnquiries } from './CustomerPendingEnquiries';
import { BulkInventoryApproval } from './BulkInventoryApproval';
import { BulkInventoryAdjustments } from './BulkInventoryAdjustments';

export const Sklad = {
	name: constants.NAME,
	constants,
	router,
	menu,
	NdSkladPreceneni,
	NdSklad,
	NdPohyb,
	NdObjednavka,
	PROrders,
	PRInvoice,
	NdCenik,
	PRReturn,
	CustomerPendingEnquiries,
	BulkInventoryApproval,
	BulkInventoryAdjustments,
};
